import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { updateMetaTags, addSiteStructuredData, getPreferredOrigin } from '../utils/metaTagsUtils';

/**
 * Custom hook to manage meta tags and canonical URLs based on the current route
 * 
 * @param title - The page title to use (optional)
 * @param description - The meta description to use (optional)
 * @param image - The image URL for social sharing (optional)
 */
export function useMetaTags(
  title?: string,
  description?: string,
  image?: string
) {
  const location = useLocation();
  
  useEffect(() => {
    // Generate default values
    const defaultTitle = 'TapDonkey';
    const defaultDescription = 'Tap-to-vote counters with optional payments';
    const origin = getPreferredOrigin();
    const defaultImage = `${origin}/images/og.png`;
    const defaultTwitterImage = `${origin}/images/tw.png`;
    
    // Use provided values or defaults
    const pageTitle = title || defaultTitle;
    const pageDescription = description || defaultDescription;
    const pageImage = image || defaultImage;
    
    // Generate the canonical URL for the current page
    // Always normalize to preferred origin to avoid GSC "Page with redirect"
    const canonicalUrl = `${origin}${location.pathname}`;
    
    // Update all meta tags
    updateMetaTags(pageTitle, pageDescription, pageImage, canonicalUrl, defaultTwitterImage);
    
    // If we're on the homepage, also add site-wide structured data
    if (location.pathname === '/' || location.pathname === '') {
      addSiteStructuredData();
    }
    
    // Return function to clean up when component unmounts or route changes
    return () => {
      // No cleanup needed for meta tags as they'll be overwritten
    };
  }, [title, description, image, location.pathname]);
} 